<div class="ds-form-field" [class.has-error]="hasError">
  <div class="ds-error-box" *ngIf="hasError"></div>

  <div
    *ngIf="errorMessage && hasError"
    [id]="id + '-error'"
    class="ds-error-text"
    role="alert">
    {{ errorMessage }}
  </div>

  <label [for]="id" class="ds-field-label">
    {{ label }}
    <span *ngIf="required" class="ds-required-asterisk" aria-hidden="true">*</span>
  </label>

  <div class="ds-input-wrapper">
    <select
      class="ds-form-select form-select"
      [id]="id"
      [value]="value"
      [required]="required"
      [attr.aria-required]="required ? 'true' : null"
      [attr.aria-invalid]="hasError ? 'true' : null"
      [attr.aria-describedby]="errorMessage && hasError ? id + '-error' : null"
      [disabled]="disabled"
      (blur)="onTouched()"
      (change)="handleSelectChange($event)"
    >
      <option value="" [selected]="!value">{{ placeholder }}</option>

      @for (option of options; track option.value) {
        <option [value]="option.value" [selected]="option.value === value">
        {{ option.label }}
        </option>
      }

    </select>
  </div>
</div>
